<template>
  <div class="comments">
    <div class="page__column">
      <div class="page__row">
        <h3 class="title">Комментарии:</h3>
      </div>

      <transition-group name="fade">
        <div class="message-item" v-for="message in comments" :key="message.id">
          <CommentMessage :message="message"
                          @reply-message="replyMessage"
                          @update-message="updateMessage"
                          @remove-message="removeMessage"
                          @toggle-controls="toggleMessageControls"
          />
        </div>
      </transition-group>

      <div class="message-area">
        <div class="message-area__input">
          <transition name="fade">
            <div class="reply-wrap" v-if="messageArea.destination.id !== null">
              <div class="replied-to">
                <span class="replied-to__close" @click.stop="unReplyMessage">
                  <svg class="close-icon" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L12 12" stroke="currentColor" stroke-width="2"/>
                    <path d="M1 12L12 1" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </span>
                {{ messageArea.destination.name }},
              </div>
              <div class="quote">
                "{{ clearUserHtml(messageArea.destination.quote) }}"
              </div>
            </div>
          </transition>
          <AppMessageInput :value="messageArea.message"
                           placeholder="Комментировать"
                           textarea-height="68px"
                           @value-changed="setMessageValue"
                           @selection-range="setInputSelectionRange"
                           @got-focus="clearValidation"
                           @send-message="sendMessage"
                           @paste-files="attachFiles"
          />
        </div>
        <div class="message-area__attachment-preview" v-if="messageArea.attachment.files.length !== 0 || messageArea.attachment.tags.length !== 0">
          <AppMessageAttachmentPreview :files="messageArea.attachment.files"
                                       :tags="messageArea.attachment.tags"
                                       :editable="true"
                                       @remove-file="removeFile"
                                       @remove-tag="removeTag"
          />
        </div>
        <div class="message-area__bottom">
          <div class="message-area__attachment">
            <AppMessageAttachment :link-tooltip="messageArea.attachment.linkTooltip"
                                  :tag-tooltip="messageArea.attachment.tagTooltip"
                                  @toggle-link-tooltip="toggleLinkTooltip"
                                  @close-link-tooltip="closeLinkTooltip"
                                  @set-link-url="setLinkUrl"
                                  @toggle-tag-tooltip="toggleTagTooltip"
                                  @close-tag-tooltip="closeTagTooltip"
                                  @set-tag-text="setTagText"
                                  @attach-files="attachFiles"
                                  @attach-link="attachLink"
                                  @attach-tag="attachTag"
                                  @clear-validation="clearValidation"
            />
          </div>
          <div class="message-area__buttons">
            <transition name="fade">
              <AppButton v-if="messageArea.updatedId"
                         type="alt"
                         title="Отменить"
                         width="140px"
                         height="30px"
                         @click.stop.native="cancelUpdate"
              />
            </transition>
            <div class="message-area__send" @click.stop="sendMessage">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66908 15.3627C4.66409 15.7632 5.10849 16.0067 5.44335 15.787L15.7635 9.01517C16.0588 8.82141 16.0656 8.39088 15.7765 8.18792L5.62958 1.06331C5.30058 0.832306 4.84731 1.06431 4.8423 1.46628L4.8034 4.58678C4.79995 4.86383 4.57186 5.08525 4.29482 5.08047L0.583236 5.01649C0.306202 5.01172 0.07811 5.23313 0.0746566 5.51019L3.96419e-05 11.4965C-0.0033905 11.7717 0.216213 11.9979 0.491383 12.0026L4.21251 12.0668C4.48768 12.0715 4.70729 12.2977 4.70386 12.5729L4.66908 15.3627Z" fill="currentColor"/>
              </svg>
            </div>
          </div>
        </div>

        <transition name="scaleDown">
            <span v-if="messageArea.valid.type" class="message-area__valid" :class="'message-area__valid_' + messageArea.valid.type">
                {{ messageArea.valid.message }}
                <img v-if=" messageArea.valid.type === 'error' " src="/img/svg/error_icon.svg" alt="Ошибка" class="message-area__valid__icon">
                <img v-if=" messageArea.valid.type === 'warning' " src="/img/svg/warning_icon.svg" alt="Внимание" class="message-area__valid__icon">
                <img v-if=" messageArea.valid.type === 'success' " src="/img/svg/success_icon.svg" alt="Успешно" class="message-area__valid__icon">
            </span>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import CommentMessage from '@/components/page/comments/CommentMessage'
import AppMessageInput from '@/components/page/input/AppMessageInput'
import AppMessageAttachment from '@/components/page/input/AppMessageAttachment'
import AppMessageAttachmentPreview from '@/components/page/input/AppMessageAttachmentPreview'
import AppButton from '@/components/page/button/AppButton'
import { clearUserHtml } from '@/utils/utils'

export default {
  name: 'the-page-comments',
  components: { AppButton, AppMessageAttachmentPreview, AppMessageAttachment, AppMessageInput, CommentMessage },
  props: {
    comments: Array,
    messageArea: Object
  },
  computed: {},
  methods: {
    setMessageValue (text) {
      this.$emit('set-message-value', text)
    },
    replyMessage (data) {
      this.$emit('reply-message', data)
    },
    unReplyMessage () {
      this.$emit('un-reply-message')
    },
    updateMessage (itemId) {
      this.$emit('update-message', itemId)
    },
    removeMessage (itemId) {
      this.$emit('remove-message', itemId)
    },
    toggleMessageControls (itemId) {
      this.$emit('toggle-message-controls', itemId)
    },
    sendMessage () {
      this.$emit('send-message')
    },
    cancelUpdate () {
      this.$emit('cancel-message-update')
    },
    // attachment
    attachFiles (files) {
      this.$emit('attach-files', files)
    },
    removeFile (data) {
      this.$emit('remove-file', data)
    },
    toggleLinkTooltip () {
      this.$emit('toggle-link-tooltip')
    },
    closeLinkTooltip () {
      this.$emit('close-link-tooltip')
    },
    setInputSelectionRange (range) {
      this.$emit('selection-range', range)
    },
    setLinkUrl (url) {
      this.$emit('set-link-url', url)
    },
    attachLink () {
      this.$emit('attach-link')
    },
    toggleTagTooltip () {
      this.$emit('toggle-tag-tooltip')
    },
    closeTagTooltip () {
      this.$emit('close-tag-tooltip')
    },
    setTagText (text) {
      this.$emit('set-tag-text', text)
    },
    attachTag () {
      this.$emit('attach-tag')
    },
    removeTag (index) {
      this.$emit('remove-tag', index)
    },
    clearValidation () {
      this.$emit('clear-validation')
    },
    // /attachment

    clearUserHtml (html) {
      return clearUserHtml(html, true)
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/vars';
@import '../../../assets/css/system/mixins';

.comments {
  padding: 28px 28px 42px;
  background: $color_sixth;
  border-radius: 3px;

  @media screen and (max-width: $tablet_start) {
    padding: 16px 16px 20px;
  }
}

.message-item {
  max-width: 824px;
  margin-bottom: 30px;
}

.message-area {
  position: relative;
  background: $color_main;
  padding-bottom: 20px;

  @media screen and (max-width: $tablet_start) {
    font-size: 14px;
  }

  &__input {
    margin-bottom: 12px;
  }

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding-right: 16px;
    padding-left: 16px;
  }

  &__attachment {
    margin-right: 20px;
  }

  &__buttons {
    display: flex;
    flex-flow: row nowrap;
  }

  &__send {
    display: flex;
    justify-content: center;
    align-items: center;
    @include size(30px);
    color: $color_main;
    background: $button_color_third;
    border-radius: 3px;
    cursor: pointer;
    transition: .3s;
    box-shadow: 0 2px 2px #13557C;
    margin-left: 12px;

    &[disabled] {
      background: $color_deactive;
      box-shadow: none;
      pointer-events: none;
    }

    &:hover {
      box-shadow: none;
    }

    &:active {
      box-shadow: inset 0 4px 4px #0E476A;
    }
  }

  &__attachment-preview {
    display: flex;
    flex-flow: row wrap;
    background: $color_main;
    color: $font_color_second;
    padding: 0 15px 12px;
  }

  &__valid {
    display: block;
    position: absolute;
    z-index: 999;
    top: 100%;
    bottom: auto;
    transform: translateY(-5px) scaleY(1);
    transform-origin: top;
    left: 0;
    width: 100%;
    font-size: 14px;
    padding: 5px 15px 0 15px;
    color: $font_color_alt;
    border-radius: 0 0 3px 3px;
    transition: .3s;

    &__icon {
      position: absolute;
      top: calc(50% - 12.5px);
      left: auto;
      right: -35px;
      animation: fadeIn .3s linear;
    }

    &_error {
      background-color: $color_error;
    }

    &_warning {
      background-color: $color_warning;
    }

    &_success {
      background-color: $color_success;
    }
  }
}

.reply-wrap {
  padding: 10px 16px 0;
}

.replied-to {
  color: $color_second-light;

  &__close {
    color: $font_color_second;
    transition: .3s;
    cursor: pointer;

    &:hover {
      color: $color_second-light;
    }
  }
}

.quote {
  padding-left: 16px;
  font-size: .8em;
  font-weight: 300;
  font-style: italic;
  color: $font_color_second;
}

.attachment-title {
  font-weight: bold;
  margin-right: 12px;
}

.attachment {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-right: 12px;
  margin-bottom: 6px;

  &__icon {
    color: #D0E7F7;
    margin-right: 10px;
    transform: translateY(-2px);
  }

  &__size {
    margin-left: 6px;
    color: $border_color;
  }

  &__link {
    color: $color_second-light;
    text-decoration: underline;
  }

  &__tag {
    color: $font_color_third;
  }
}
</style>
